import {
  type SearchSessionExpiryReason,
  searchSessionExpiryReasonSchema,
} from '@massilia/contracts'
import { AxiosError } from 'axios'
import { z } from 'zod'

/** Corps du 410 « session expirée » : tout autre corps repart en `null`. */
const expirySchema = z.object({ reason: searchSessionExpiryReasonSchema })

/**
 * Extrait la cause machine-lisible d'une expiration de session de recherche.
 *
 * Le serveur répond `SEARCH_SESSION_EXPIRED` pour deux situations distinctes —
 * l'offre n'existe plus de notre côté, ou son tarif a bougé chez le fournisseur
 * — parce que ce code est gelé et que `apps/web` branche dessus sa relance de
 * recherche. Le discriminant voyage donc dans `reason`, que le filtre serveur
 * recopie dans le corps au titre d'une liste blanche.
 *
 * Le parsing est volontairement défensif : un corps venu d'ailleurs (HTML d'un
 * proxy, réponse d'un serveur antérieur à ce champ) retombe sur `null`, et
 * l'écran garde son libellé d'expiration — celui qu'il affichait déjà.
 */
export function parseSearchSessionExpiryReason(error: Error): null | SearchSessionExpiryReason {
  if (!(error instanceof AxiosError)) return null

  const body = expirySchema.safeParse(error.response?.data)
  return body.success ? body.data.reason : null
}
